import { WOW_PRICE_CT_DT_EXPERIMENT_KEY } from '@/constants/flights'
import { useWowPricingState } from '@/hooks/useWowPricingState'

/** Single experiment for domestic + international SRP and itinerary. */
export function getWowExperimentKey(_isIntl?: boolean): string {
    return WOW_PRICE_CT_DT_EXPERIMENT_KEY
}

/**
 * Resolves the active WOW Statsig variant and gate via `wow_price_ct_dt`.
 * `isIntl` is kept for call-site compatibility but no longer selects a different experiment.
 */
export function useWowPricingExperiment(_isIntl?: boolean) {
    const { wowPricingVariant, wowOn } = useWowPricingState()

    return { wowPricingVariant, wowOn }
}

export default useWowPricingExperiment
